import React from 'react'
import Link from 'next/link'
import { DataAttr } from 'frontend/types'

interface SpaLinkProps extends DataAttr {
  href: string
  children: React.ReactNode
  'aria-describedby'?: string
  className?: string
  onClick?: () => void
  tabIndex?: number
  id?: string
  target?: string
}

const SpaLink = ({ href, children, ...rest }: SpaLinkProps) => {
  return (
    <Link href={href} {...rest}>
      {children}
    </Link>
  )
}

export default SpaLink
